var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_166",
    "data-name": "Rectangle 166",
    width: 39,
    height: 24,
    transform: "translate(0 0.488)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(-1252 -3066)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 32.5,
    cy: 32.5,
    r: 32.5,
    transform: "translate(1252 3066)",
    fill: "#ee8b3f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M49.224,62.693A1.225,1.225,0,0,1,48,61.469V49.224a1.224,1.224,0,0,1,2.449,0V61.469a1.225,1.225,0,0,1-1.224,1.224",
    transform: "translate(1221.898 3043.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M97.224,62.693A1.225,1.225,0,0,1,96,61.469V49.224a1.224,1.224,0,0,1,2.449,0V61.469a1.225,1.225,0,0,1-1.224,1.224",
    transform: "translate(1178.795 3043.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M145.224,62.693A1.225,1.225,0,0,1,144,61.469V49.224a1.224,1.224,0,0,1,2.449,0V61.469a1.225,1.225,0,0,1-1.224,1.224",
    transform: "translate(1135.693 3043.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M193.224,62.693A1.225,1.225,0,0,1,192,61.469V49.224a1.224,1.224,0,0,1,2.449,0V61.469a1.225,1.225,0,0,1-1.224,1.224",
    transform: "translate(1092.59 3043.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M241.224,62.693A1.225,1.225,0,0,1,240,61.469V49.224a1.224,1.224,0,0,1,2.449,0V61.469a1.225,1.225,0,0,1-1.224,1.224",
    transform: "translate(1049.488 3043.409)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_165",
    "data-name": "Rectangle 165",
    width: 39,
    height: 24,
    transform: "translate(1265 3087)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_114",
    "data-name": "Group 114",
    transform: "translate(1265 3086.512)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M289.224,62.693A1.225,1.225,0,0,1,288,61.469V49.224a1.224,1.224,0,1,1,2.449,0V61.469a1.225,1.225,0,0,1-1.224,1.224",
    transform: "translate(-258.614 -43.102)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M31.427,24.488H4.49A4.494,4.494,0,0,1,0,20V4.49A4.494,4.494,0,0,1,4.49,0H31.427a4.494,4.494,0,0,1,4.49,4.49V4.9h.393a2.86,2.86,0,0,1,2.857,2.857v8.979a2.86,2.86,0,0,1-2.857,2.857h-.393V20a4.494,4.494,0,0,1-4.49,4.49M4.49,2.449A2.044,2.044,0,0,0,2.449,4.49V20A2.044,2.044,0,0,0,4.49,22.039H31.427A2.044,2.044,0,0,0,33.467,20V18.366a1.225,1.225,0,0,1,1.224-1.224H36.31a.408.408,0,0,0,.408-.408V7.755a.408.408,0,0,0-.408-.408H34.692a1.225,1.225,0,0,1-1.224-1.224V4.49a2.044,2.044,0,0,0-2.041-2.041Z",
    transform: "translate(0 0)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup3);
export default __webpack_public_path__ + "static/media/Group3.5ed8b67236b33a2178f4220bc3ea197d.svg";
export { ForwardRef as ReactComponent };